import { generatePath } from 'react-router-dom';
import { gameConfig } from '../../../shared/gameConfig';
import frontendLog from '../libs/frontendLog';
import { TWoweraRoutes } from '../../../../../shared/gameConfig/wowera/routes';

export const namedRoutes = gameConfig.Routes as TWoweraRoutes;

export function resolveRoutePath(path: string, params?: Object): string {
  try {
    return generatePath(path, params);
  } catch (err) {
    frontendLog.error({ err, path, params }, 'resolveRoutePath failed');
    return '/';
  }
}
